import { all, takeLatest } from 'redux-saga/effects';

import * as actionTypes from '../actionTypes';

import { displayErrorNotification, displayNotification, displaySuccessNotification } from './displayNotifications';

export default function* watchNotifications() {
    yield all([
        takeLatest(actionTypes.DISPLAY_ERROR_NOTIFICATION, displayErrorNotification),
        takeLatest(actionTypes.DISPLAY_DEFAULT_NOTIFICATION, displayNotification),
        takeLatest(actionTypes.DISPLAY_SUCCESS_NOTIFICATION, displaySuccessNotification),
    ]);
}
